module.exports = __webpack_public_path__ + "img/16800.9085b4d3.jpg";